import type { WidgetPreviewConfig } from './types';
import { WidgetAvatar } from './widget-avatar';
import { CloseIcon } from './widget-icons';
import styles from './widget-preview.module.scss';

interface WelcomePreviewProps {
  config: WidgetPreviewConfig;
  onOpen: () => void;
  onClose: () => void;
  onAction: (action: string) => void;
}

export const WelcomePreview = ({ config, onOpen, onClose, onAction }: WelcomePreviewProps) => {
  const isStatic = config.preview.mode === 'static';
  const message =
    (isStatic ? config.preview.staticQuestion : config.content.welcomeMessage) ||
    config.content.welcomeMessage;
  const actions = isStatic ? config.preview.staticAnswers : config.content.quickQuestions;

  return (
    <div className={styles.welcomePreview}>
      <div
        className={styles.welcomeCard}
        style={{ borderRadius: config.welcome.messageBorderRadius }}
      >
        <WidgetAvatar appearance={config.appearance} size={33} className={styles.welcomeAvatar} />
        <div className={styles.welcomeContent}>
          <div className={styles.welcomeActionsTop}>
            <button
              type="button"
              className={styles.showMoreButton}
              style={{ borderRadius: config.welcome.hintBorderRadius }}
              onClick={onOpen}
            >
              {config.translations.welcomeShowMoreLabel}
            </button>
            <button
              type="button"
              className={styles.closeButton}
              style={{ borderRadius: config.welcome.hintBorderRadius }}
              onClick={onClose}
              aria-label={config.translations.welcomeCloseAriaLabel}
            >
              <CloseIcon />
            </button>
          </div>
          <div className={styles.welcomeMeta}>
            <strong>{config.content.assistantName}</strong>
            <span>{config.translations.welcomeNowLabel}</span>
          </div>
          <p>{message}</p>
        </div>
      </div>
      {config.welcome.showAgentAnswerHints && actions.length > 0 && (
        <div className={styles.welcomeHints}>
          {actions.map((action, index) => (
            <button
              key={`${action}-${index}`}
              type="button"
              style={{ borderRadius: config.welcome.hintBorderRadius }}
              onClick={() => onAction(action)}
            >
              {action}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
